import { render, staticRenderFns } from "./TestPlanTable.vue?vue&type=template&id=39f2eb7c&scoped=true&"
import script from "./TestPlanTable.vue?vue&type=script&lang=js&"
export * from "./TestPlanTable.vue?vue&type=script&lang=js&"
import style0 from "./TestPlanTable.vue?vue&type=style&index=0&id=39f2eb7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f2eb7c",
  null
  
)

export default component.exports